import styled from 'styled-components';

export const Title = styled.h2`
    margin: 2rem 0 4rem 0; 
    border-bottom: 5px double black;
    border-top: ${({borderTop}) => borderTop ? `${borderTop}` : '5px double black'};
    border: ${({ border }) => border && `${border}`};
    padding: 1rem;
`;
export const NewsSection = styled.section`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    column-gap: 3rem;
    row-gap: 3rem;  

    @media(max-width: 900px) {
        column-gap: 2rem;
    }

    @media(max-width: 700px) {
        column-gap: 1rem;
    }

    @media(max-width: 590px) {
        grid-template-columns: repeat(2, 1fr);
    }
    
    @media(max-width: 500px) {
        grid-template-columns: 1fr;
    }
`;

export const Article = styled.article`
    margin: 0;
`;

export const ArticleHeading = styled.h2`
    margin: 0 0 0.5rem 0;

    a:hover {
        color: #ff6f69
    }
    @media(max-width: 770px) {
        font-size: 2rem;
    }
`;

export const ArticleCategory = styled.span`
    font-weight: bold;

`;

export const ArticleAbstract = styled.p`
    font-size: 2rem;
    margin: 1rem 0;
    @media(max-width: 770px) {
        font-size: 1.8rem;
    }
`;

